<template>
  <div v-if="objDTO !== null">
    <div class="container">
      <div class="white-frame" v-if="stage == 1">
        <div class="title-text mb-3">
          <b>Dados do Sinistro</b>
        </div>
        <div class="row g-3">
          <div class="col-md-6">
            <label class="form-label" for="sinistroData">Data Sinistro</label>
            <Calendar
              id="sinistroData"
              v-model="objDTO.Sinistro.SinistroData"
              dateFormat="dd/mm/yy"
              disabled
              class="form-control p-0"
            />
          </div>
          <div
            class="col-md-6"
            :class="{
              'field-required': $v.objDTO.Sinistro.SinistroData.$invalid,
            }"
          >
            <label class="form-label" for="sinistroHora">Hora Sinistro</label>
            <Calendar
              id="sinistroHora"
              v-model="objDTO.Sinistro.SinistroData"
              dateFormat="dd/mm/yy"
              :timeOnly="true"
              hourFormat="24"
              :showSeconds="false"
              :manualInput="false"
              class="form-control p-0"
            />
          </div>
          <div
            class="col-md-12"
            :class="{
              'field-required': $v.objDTO.Sinistro.SinistroDescricao.$invalid,
            }"
          >
            <label class="form-label" for="sinistroDesc"
              >Descrição Ocorrência</label
            >
            <Textarea
              id="sinistroDesc"
              v-model="objDTO.Sinistro.SinistroDescricao"
              :autoResize="true"
              rows="5"
              cols="30"
              class="form-control"
            />
          </div>

          <div class="col-md-12">
            <label class="form-label" for="produtoDesc"
              >Descrição do Produto</label
            >
            <Textarea
              id="produtoDesc"
              v-model="objDTO.ProcessoGDM.DescricaoGeral"
              :autoResize="true"
              maxlength="1000"
              rows="5"
              cols="30"
              class="form-control"
            />
          </div>
          <loading-state v-if="loading.coverages" />
        </div>

        <div
          v-if="!loading.coverages"
          class="row g-3"
          :class="{
            'field-required':
              $v.objDTO.Apolice.UnidadeDeRiscoExternalId.$invalid,
          }"
        >
          <div class="col-md-6" v-if="riskUnits.length > 1">
            <label class="form-label" for="riskUnit">Unidade de Risco</label>
            <Dropdown
              id="riskUnit"
              placeholder="Selecione"
              v-model="objDTO.Apolice.UnidadeDeRiscoExternalId"
              :options="riskUnits"
              optionLabel="Description"
              optionValue="RiskUnitId"
              class="form-control p-0"
            />
          </div>
          <div
            class="col-md-6"
            v-if="insuranceObjects.length > 1"
            :class="{
              'field-required':
                $v.objDTO.Apolice.ObjectoSeguradoExternalId.$invalid,
            }"
          >
            <label class="form-label" for="insuranceObject"
              >Objeto Segurado</label
            >
            <Dropdown
              id="insuranceObject"
              placeholder="Selecione"
              v-model="objDTO.Apolice.ObjectoSeguradoExternalId"
              :options="insuranceObjects"
              optionLabel="Description"
              optionValue="InsuranceObjectId"
              class="form-control p-0"
            />
          </div>
          <div
            class="col-md-6"
            :class="{
              'field-required': $v.objDTO.Apolice.ApoliceCoberturaId.$invalid,
            }"
          >
            <label class="form-label" for="coverages">Cobertura</label>
            <Dropdown
              id="coverages"
              placeholder="Selecione"
              @change="changeCoverage"
              v-model="objDTO.Apolice.ApoliceCoberturaId"
              :options="coverages"
              optionLabel="Description"
              optionValue="GisCoverageId"
              class="form-control p-0"
            />
          </div>
          <div
            class="col-md-6"
            v-if="coverages.length > 0"
            :class="{
              'field-required': $v.objDTO.Sinistro.SinistroEventoId.$invalid,
            }"
          >
            <label class="form-label" for="evento">Evento</label>
            <Dropdown
              id="evento"
              placeholder="Selecione"
              v-model="objDTO.Sinistro.SinistroEventoId"
              :options="events"
              optionLabel="Description"
              optionValue="Id"
              class="form-control p-0"
            />
          </div>

          <div
            class="col-md-6"
            v-if="coverages.length > 0"
            :class="{
              'field-required': $v.categoriaId.$invalid,
            }"
          >
            <label class="form-label" for="linhaProduto">Linha Produto</label>
            <Dropdown
              id="linhaProduto"
              placeholder="Selecione"
              v-model="categoriaId"
              @change="changeLinhaProduto"
              :options="gdmCategoria"
              optionLabel="Description"
              optionValue="Id"
              data-key="Id"
              class="form-control p-0"
            />
          </div>
          <div
            class="col-md-6"
            v-if="coverages.length > 0"
            :class="{
              'field-required': $v.objDTO.ProcessoGDM.GDMTipoId.$invalid,
            }"
          >
            <label class="form-label" for="produto">Produto</label>
            <Dropdown
              id="produto"
              placeholder="Selecione"
              v-model="objDTO.ProcessoGDM.GDMTipoId"
              @change="changeProduto"
              :options="gdmTipo"
              optionLabel="Description"
              optionValue="Id"
              data-key="Id"
              class="form-control p-0"
            />
          </div>

          <div
            v-if="objDTO.ProcessoGDM.GDMTipoId == 17"
            class="col-md-6"
            :class="{
              'field-required': $v.objDTO.ProcessoGDM.IMEI.$invalid,
            }"
          >
            <label class="form-label" for="imei">IMEI</label>
            <InputText
              id="imei"
              v-model="objDTO.ProcessoGDM.IMEI"
              class="form-control"
            />
          </div>
        </div>
      </div>
    </div>

    <!-- new -->
    <div class="container" v-if="stage == 1 && !loading.coverages">
      <div class="white-frame">
        <div class="title-text mb-3">
          <b>Local da Ocorrência</b>
        </div>
        <div class="row g-3">
          <div
            class="col-md-6"
            :class="{
              'field-required':
                $v.objDTO.Sinistro.SinistroCodigoPostal.$invalid,
            }"
          >
            <label class="form-label" for="cep">CEP</label>
            <InputText
              v-model="objDTO.Sinistro.SinistroCodigoPostal"
              class="form-control"
              @input="changeCepSinistro"
            />
          </div>
          <div
            class="col-md-6"
            :class="{
              'field-required': $v.objDTO.Sinistro.SinistroDistritoId.$invalid,
            }"
          >
            <label class="form-label" for="estado">
              Estado
              <i
                class="pi pi-spin pi-spinner p-ml-2"
                v-if="districts.length == 0"
              />
            </label>
            <Dropdown
              id="estado"
              placeholder="Selecione"
              v-model="objDTO.Sinistro.SinistroDistritoId"
              :options="districts"
              :filter="true"
              optionLabel="Description"
              optionValue="Id"
              @change="changeStateOcorrencia"
              class="form-control p-0"
              :disabled="loading.distritoSinistro"
            />
          </div>

          <div
            class="col-md-6"
            :class="{
              'field-required': $v.objDTO.Sinistro.SinistroConcelhoId.$invalid,
            }"
          >
            <label class="form-label" for="cidade">
              Cidade
              <i
                class="pi pi-spin pi-spinner p-ml-2"
                v-if="loading.cidadeSinistro"
              />
            </label>
            <Dropdown
              id="cidade"
              placeholder="Selecione"
              v-model="objDTO.Sinistro.SinistroConcelhoId"
              :options="citiesSinistro"
              :filter="true"
              optionLabel="Description"
              optionValue="Id"
              @change="changeCityOcorrencia"
              class="form-control p-0"
            />
          </div>
          <div
            class="col-md-6"
            :class="{
              'field-required': $v.objDTO.Sinistro.SinistroFreguesiaId.$invalid,
            }"
          >
            <label class="form-label" for="bairro">
              Bairro
              <i
                class="pi pi-spin pi-spinner p-ml-2"
                v-if="loading.bairroSinistro"
              />
            </label>
            <Dropdown
              id="bairro"
              placeholder="Selecione"
              v-model="objDTO.Sinistro.SinistroFreguesiaId"
              :options="parishesSinistro"
              :filter="true"
              optionLabel="Description"
              optionValue="Id"
              class="form-control p-0"
            />
          </div>

          <div
            class="col-md-6"
            :class="{
              'field-required': $v.objDTO.Sinistro.SinistroMorada.$invalid,
            }"
          >
            <label class="form-label" for="logradouro">Logradouro</label>
            <InputText
              id="logradouro"
              v-model="objDTO.Sinistro.SinistroMorada"
              class="form-control"
            />
          </div>
          <div
            class="col-md-6"
            :class="{
              'field-required':
                $v.objDTO.Sinistro.SinistroMoradaNrPorta.$invalid,
            }"
          >
            <label class="form-label" for="moradaNr">Nr</label>
            <InputText
              id="moradaNr"
              v-model="objDTO.Sinistro.SinistroMoradaNrPorta"
              class="form-control"
            />
          </div>

          <div
            class="col-md-6"
            :class="{
              'field-required':
                $v.objDTO.Sinistro.SinistroLocalReferencia.$invalid,
            }"
          >
            <label class="form-label" for="moradaComp">Complemento</label>
            <InputText
              id="moradaComp"
              v-model="objDTO.Sinistro.SinistroLocalReferencia"
              class="form-control"
            />
          </div>
        </div>
      </div>
    </div>
    <div class="container" v-if="stage == 1 && !loading.coverages">
      <div class="white-frame">
        <div class="title-text mb-3">
          <b>Endereço para envio do produto:</b>
        </div>
        <div class="row g-3">
          <div
            class="col-md-6"
            :class="{
              'field-required':
                $v.objDTO.ProcessoGDM.ProdutoEnvioContacto.CodPostal.$invalid,
            }"
          >
            <label class="form-label" for="cepEnvio">CEP</label>
            <InputText
              v-model="objDTO.ProcessoGDM.ProdutoEnvioContacto.CodPostal"
              class="form-control"
              @input="changeCepEnvio"
            />
          </div>
          <div
            class="col-md-6"
            :class="{
              'field-required':
                $v.objDTO.ProcessoGDM.ProdutoEnvioContacto.DistritoId.$invalid,
            }"
          >
            <label class="form-label" for="estadoEnvio">
              Estado
              <i
                class="pi pi-spin pi-spinner p-ml-2"
                v-if="districts.length == 0"
              />
            </label>
            <Dropdown
              id="estadoEnvio"
              placeholder="Selecione"
              v-model="objDTO.ProcessoGDM.ProdutoEnvioContacto.DistritoId"
              :options="districts"
              :filter="true"
              optionLabel="Description"
              optionValue="Id"
              @change="changeStateEnvio"
              class="form-control p-0"
              :disabled="loading.distritoEnvio"
            />
          </div>

          <div
            class="col-md-6"
            :class="{
              'field-required':
                $v.objDTO.ProcessoGDM.ProdutoEnvioContacto.ConcelhoId.$invalid,
            }"
          >
            <label class="form-label" for="cidadeEnvio">
              Cidade
              <i
                class="pi pi-spin pi-spinner p-ml-2"
                v-if="loading.cidadeEnvio"
              />
            </label>
            <Dropdown
              id="cidadeEnvio"
              placeholder="Selecione"
              v-model="objDTO.ProcessoGDM.ProdutoEnvioContacto.ConcelhoId"
              :options="citiesEnvio"
              :filter="true"
              optionLabel="Description"
              optionValue="Id"
              @change="changeCityEnvio"
              class="form-control p-0"
            />
          </div>
          <div
            class="col-md-6"
            :class="{
              'field-required':
                $v.objDTO.ProcessoGDM.ProdutoEnvioContacto.FreguesiaId.$invalid,
            }"
          >
            <label class="form-label" for="bairroEnvio">
              Bairro
              <i
                class="pi pi-spin pi-spinner p-ml-2"
                v-if="loading.bairroEnvio"
              />
            </label>
            <Dropdown
              id="bairroEnvio"
              placeholder="Selecione"
              v-model="objDTO.ProcessoGDM.ProdutoEnvioContacto.FreguesiaId"
              :options="parishesEnvio"
              :filter="true"
              optionLabel="Description"
              optionValue="Id"
              class="form-control p-0"
            />
          </div>

          <div
            class="col-md-6"
            :class="{
              'field-required':
                $v.objDTO.ProcessoGDM.ProdutoEnvioContacto.Morada.$invalid,
            }"
          >
            <label class="form-label" for="logradouroEnvio">Logradouro</label>
            <InputText
              id="logradouroEnvio"
              v-model="objDTO.ProcessoGDM.ProdutoEnvioContacto.Morada"
              class="form-control"
            />
          </div>
          <div
            class="col-md-6"
            :class="{
              'field-required':
                $v.objDTO.ProcessoGDM.ProdutoEnvioContacto.MoradaNrPorta
                  .$invalid,
            }"
          >
            <label class="form-label" for="moradaNrEnvio">Nr</label>
            <InputText
              id="moradaNrEnvio"
              v-model="objDTO.ProcessoGDM.ProdutoEnvioContacto.MoradaNrPorta"
              class="form-control"
            />
          </div>

          <div
            class="col-md-6"
            :class="{
              'field-required':
                $v.objDTO.ProcessoGDM.ProdutoEnvioContacto.CodPostalLocalidade
                  .$invalid,
            }"
          >
            <label class="form-label" for="moradaCompEnvio">Complemento</label>
            <InputText
              id="moradaCompEnvio"
              v-model="
                objDTO.ProcessoGDM.ProdutoEnvioContacto.CodPostalLocalidade
              "
              class="form-control"
            />
          </div>
        </div>
        <!-- <div class="col-12 Aligner aligner-right" v-if="!$v.objDTO.$invalid">
          <button
            class="button-base-small btn-grey font-small mx-1"
            @click="stage = 1"
          >
            Voltar
          </button>
        </div>-->
        <div
          class="col-12 Aligner aligner-right mt-4"
          v-if="!$v.objDTO.$invalid"
        >
          <button
            class="button-base-small btn-green font-small mx-1"
            @click="stage = 2"
          >
            Finalizar
          </button>
        </div>
      </div>
    </div>

    <div v-if="stage === 2">
      <div class="container">
        <div class="white-frame">
          <div class="title-text mb-3">
            <b>Resumo das informações para acionamento de Seguro</b>
          </div>

          <resume-garantia-estendida
            :objDTO="objDTO"
            :events="events"
            :coverages="coverages"
            :estados="districts"
            :cidadesSinistro="citiesSinistro"
            :cidadesEnvio="citiesEnvio"
            :bairrosSinistro="parishesSinistro"
            :bairrosEnvio="parishesEnvio"
            :gdmTipo="gdmTipo"
            :riskUnits="riskUnits"
            :insuranceObjects="insuranceObjects"
            @back="back"
          />
        </div>
      </div>
    </div>
  </div>
</template>

<script>
// import DadosComunicante from "../components/DadosComunicante.vue";
// import DadosSegurado from "../components/DadosSegurado.vue";
// import PesquisaApolice from "../components/PesquisaApolice.vue";
import ResumeGarantiaEstendida from '../components/Resume/ResumeGarantiaEstendida.vue';
import LoadingState from '../components/LoadingState.vue';

import {
  required,
  // requiredIf,
  minLength,
  maxLength,
  numeric,
} from 'vuelidate/lib/validators';
import {
  cpfCnpjValid,
  dateAfterToday,
  cepValid,
  inputClean,
} from '../utils/customValidations';
import { getInfoByOperationPK } from '../utils/helpers';
import {
  getEvents,
  getOptions,
  getDistricts,
  getCities,
  getParish,
  getCepInfo,
  getInsuranceObjectDetails,
  getGDMCategoria,
  getGDMTipoByCategoria,
} from '../api/formMethods';
// import VueScrollTo from "vue-scrollto";
import Swal from 'sweetalert2';

import dayjs from 'dayjs';
import utc from 'dayjs/plugin/utc';
import customParseFormat from 'dayjs/plugin/customParseFormat';
import isSameOrAfter from 'dayjs/plugin/isSameOrAfter';
import { fireVigenciaCoberuraErrorGE } from '../utils/helpers';
dayjs.extend(utc);
dayjs.extend(customParseFormat);
dayjs.extend(isSameOrAfter);

export default {
  components: {
    // DadosComunicante,
    // DadosSegurado,
    // PesquisaApolice,
    ResumeGarantiaEstendida,
    LoadingState,
  },
  data() {
    return {
      stage: 1,
      objDTO: null,
      operationPK: null,
      gisRamoId: null,
      gisProdutoId: null,
      optionYN: [],
      loading: {
        coverages: false,
        distritoSinistro: false,
        cidadeSinistro: false,
        bairroSinistro: false,
        distritoEnvio: false,
        cidadeEnvio: false,
        bairroEnvio: false,
      },
      insuranceObjects: [],
      riskUnits: [],
      coverages: [],
      events: [],
      districts: [],
      citiesSinistro: [],
      parishesSinistro: [],
      citiesEnvio: [],
      parishesEnvio: [],
      gdmCategoria: [],
      categoriaId: null,
      gdmTipo: [],
    };
  },
  validations() {
    return {
      categoriaId: { required },
      objDTO: {
        Apolice: {
          ApoliceCoberturaId: { required },
          UnidadeDeRiscoExternalId: { required },
          ObjectoSeguradoExternalId: { required },
        },
        ComunicanteContacto: {
          ParentescoId: {
            required,
          },
        },
        SeguradoContacto: {
          Nome: { required, inputClean },
          NrContribuinte: { required, cpfCnpjValid },
          DataNascimento: { required, dateAfterToday },
          nrID: { required, inputClean },
        },
        Sinistro: {
          SinistroData: { required, dateAfterToday },
          SinistroEventoId: { required },
          SinistroDescricao: { required, inputClean },
          SinistroCodigoPostal: { required, cepValid },
          SinistroDistritoId: { required },
          SinistroConcelhoId: { required },
          SinistroFreguesiaId: { required },
          SinistroMorada: { required, inputClean },
          SinistroMoradaNrPorta: { required, inputClean },
          SinistroLocalReferencia: { inputClean },
          // SinistroMoradaNrPorta
          // SinistroLocalReferencia
          // ConstatacaoDanosOpcaoId: {
          //   required:
          //     this.objDTO.Apolice.ApoliceCoberturaId == 2698 ? required : {},
          // },
        },
        ProcessoGDM: {
          GDMTipoId: { required },
          IMEI:
            this.objDTO.ProcessoGDM.GDMTipoId == 17
              ? {
                  required,
                  minLength: minLength(15),
                  maxLength: maxLength(15),
                  numeric,
                }
              : {},
          // IMEI: {
          //   required: this.objDTO.ProcessoGDM.GDMTipoId == 1 ? required : {},
          //   minLength:
          //     this.objDTO.ProcessoGDM.GDMTipoId == 1 ? minLength(15) : {},
          //   maxLength:
          //     this.objDTO.ProcessoGDM.GDMTipoId == 1 ? maxLength(15) : {},
          // },
          ProdutoEnvioContacto: {
            CodPostal: { required, cepValid },
            DistritoId: { required },
            ConcelhoId: { required },
            FreguesiaId: { required },
            Morada: { required, inputClean },
            MoradaNrPorta: { required, inputClean },
            CodPostalLocalidade: { inputClean },
            //MoradaNrPorta:{required}
            // CodPostalLocalidade  :{required}
          },
        },
      },
    };
  },
  methods: {
    vinculoSegurado(contacto) {
      if (this.objDTO.ComunicanteContacto.ParentescoId == 1) {
        this.objDTO.SeguradoContacto.Nome = contacto.nome;
        this.objDTO.SeguradoContacto.NrContribuinte = contacto.cpf;
      } else {
        this.objDTO.SeguradoContacto.Nome = null;
        this.objDTO.SeguradoContacto.NrContribuinte = null;
      }
    },
    back(newStage) {
      this.stage = newStage;
    },
    async policySelected(operationPK) {
      if (operationPK) {
        this.operationPK = operationPK;
        this.showSinistro = true;

        // VueScrollTo.scrollTo(this.$refs.dadosComunicante);
        window.scrollTo(0, 0);

        try {
          this.loading.coverages = true;

          const {
            riskUnit,
            riskUnits,
            insuranceObject,
            insuranceObjects,
            coverage,
            coverages,
            events,
          } = await getInfoByOperationPK(
            operationPK,
            this.objDTO.Apolice.ApoliceProdutoId,
            this.objDTO.Sinistro.SinistroRamoId
          );

          const damageId = insuranceObjects.find(
            (x) => x.InsuranceObjectId == insuranceObject
          ).DamageId;
          const templateId = insuranceObjects.find(
            (x) => x.InsuranceObjectId == insuranceObject
          ).TemplateId;
          const symbols = [
            'MarcaProduto',
            'ModeloProduto',
            'NumeroNotaFiscal',
            'DataNotaFiscal',
          ];
          const insuranceObjectDetailsResult = await getInsuranceObjectDetails(
            damageId,
            templateId,
            symbols
          );

          const { Damages } = insuranceObjectDetailsResult;
          const { Properties } = Damages[0];

          const marcaProduto = Properties.find(
            (x) => x.Symbol == 'MarcaProduto'
          )?.Value;
          const modeloProduto = Properties.find(
            (x) => x.Symbol == 'ModeloProduto'
          )?.Value;
          const dataNotaFiscal = Properties.find(
            (x) => x.Symbol == 'DataNotaFiscal'
          )?.Value;
          const numeroNotaFiscal = Properties.find(
            (x) => x.Symbol == 'NumeroNotaFiscal'
          )?.Value;

          this.objDTO.ProcessoGDM.Marca = marcaProduto;
          this.objDTO.ProcessoGDM.Modelo = modeloProduto;
          this.objDTO.ProcessoGDM.CompraNrFactura = numeroNotaFiscal;
          this.objDTO.ProcessoGDM.CompraData = dataNotaFiscal;
          this.objDTO.Apolice.UnidadeDeRiscoExternalId = riskUnit;
          this.objDTO.Apolice.ObjectoSeguradoExternalId = insuranceObject;
          this.objDTO.Apolice.ApoliceCoberturaId = coverage;
          this.riskUnits = riskUnits;
          this.events = events;
          this.insuranceObjects = insuranceObjects;
          this.coverages = coverages;
        } catch (error) {
          console.error(error);
        } finally {
          this.loading.coverages = false;
        }
      }
    },
    async changeCepSinistro() {
      if (!this.$v.objDTO.Sinistro.SinistroCodigoPostal.$invalid) {
        this.loading.distritoSinistro = true;
        const res = await getCepInfo(this.objDTO.Sinistro.SinistroCodigoPostal);
        //console.log(res);

        const anyEmpty = Object.values(res).some((x) => x === null || x === '');
        const { DistritoUonId, ConcelhoUonId, FreguesiaUonId, Morada } = res;
        this.loading.distritoSinistro = false;

        if (DistritoUonId) {
          this.objDTO.Sinistro.SinistroDistritoId = DistritoUonId;
          await this.changeStateOcorrencia();
        }
        if (ConcelhoUonId) {
          this.objDTO.Sinistro.SinistroConcelhoId = ConcelhoUonId;
          await this.changeCityOcorrencia();
        }

        if (FreguesiaUonId)
          this.objDTO.Sinistro.SinistroFreguesiaId = FreguesiaUonId;

        if (Morada) this.objDTO.Sinistro.SinistroMorada = Morada;

        if (anyEmpty) {
          Swal.fire({
            toast: true,
            icon: 'warning',
            position: 'top',
            title:
              'Algumas informações do cep não foram retornadas, preencha manualmente',
            showConfirmButton: false,
            timer: 4000,
            timerProgressBar: true,
            didOpen: (toast) => {
              toast.addEventListener('mouseenter', Swal.stopTimer);
              toast.addEventListener('mouseleave', Swal.resumeTimer);
            },
          });
        }
      }
    },
    async changeCepEnvio() {
      if (!this.$v.objDTO.ProcessoGDM.ProdutoEnvioContacto.CodPostal.$invalid) {
        this.loading.distritoEnvio = true;
        const res = await getCepInfo(
          this.objDTO.ProcessoGDM.ProdutoEnvioContacto.CodPostal
        );

        const anyEmpty = Object.values(res).some((x) => x === null || x === '');
        const { DistritoUonId, ConcelhoUonId, FreguesiaUonId, Morada } = res;
        this.loading.distritoEnvio = false;

        if (DistritoUonId) {
          this.objDTO.ProcessoGDM.ProdutoEnvioContacto.DistritoId = DistritoUonId;
          await this.changeStateEnvio();
        }
        if (ConcelhoUonId) {
          this.objDTO.ProcessoGDM.ProdutoEnvioContacto.ConcelhoId = ConcelhoUonId;
          await this.changeCityEnvio();
        }

        if (FreguesiaUonId)
          this.objDTO.ProcessoGDM.ProdutoEnvioContacto.FreguesiaId = FreguesiaUonId;

        if (Morada)
          this.objDTO.ProcessoGDM.ProdutoEnvioContacto.Morada = Morada;

        if (anyEmpty) {
          Swal.fire({
            toast: true,
            icon: 'warning',
            position: 'top',
            title:
              'Algumas informações do cep não foram retornadas, preencha manualmente',
            showConfirmButton: false,
            timer: 4000,
            timerProgressBar: true,
            didOpen: (toast) => {
              toast.addEventListener('mouseenter', Swal.stopTimer);
              toast.addEventListener('mouseleave', Swal.resumeTimer);
            },
          });
        }
      }
    },
    async changeStateOcorrencia() {
      this.loading.cidadeSinistro = true;
      this.objDTO.Sinistro.SinistroConcelhoId = null;
      this.objDTO.Sinistro.SinistroFreguesiaId = null;
      this.parishesSinistro = [];
      this.citiesSinistro = [];
      this.citiesSinistro = await getCities(
        this.objDTO.Sinistro.SinistroDistritoId
      );
      this.loading.cidadeSinistro = false;
      // console.log(this.citiesSinistro);
    },

    async changeCityOcorrencia() {
      this.loading.bairroSinistro = true;
      this.objDTO.Sinistro.SinistroFreguesiaId = null;
      this.parishesSinistro = [];
      this.parishesSinistro = await getParish(
        this.objDTO.Sinistro.SinistroConcelhoId
      );
      this.loading.bairroSinistro = false;
    },

    async changeStateEnvio() {
      this.loading.cidadeEnvio = true;
      this.objDTO.ProcessoGDM.ProdutoEnvioContacto.ConcelhoId = null;
      this.objDTO.ProcessoGDM.ProdutoEnvioContacto.FreguesiaId = null;
      this.parishesEnvio = [];
      this.citiesEnvio = [];
      this.citiesEnvio = await getCities(
        this.objDTO.ProcessoGDM.ProdutoEnvioContacto.DistritoId
      );
      this.loading.cidadeEnvio = false;
    },

    async changeCityEnvio() {
      this.loading.bairroEnvio = true;
      this.objDTO.ProcessoGDM.ProdutoEnvioContacto.FreguesiaId = null;
      this.parishesEnvio = [];
      this.parishesEnvio = await getParish(
        this.objDTO.ProcessoGDM.ProdutoEnvioContacto.ConcelhoId
      );
      this.loading.bairroEnvio = false;
    },

    async changeCoverage() {
      //======================================================================
      //Verificar se a Cobertura escolhida está dentro da vigência da Apólice
      //======================================================================
      var selectedApoliceCoberturaId = this.objDTO.Apolice.ApoliceCoberturaId;
      //console.log("Cobertura Selected -> " + selectedApoliceCoberturaId);

      //console.log(this.coverages);

      var coberturaInfo = this.coverages.find(
        (element) => element.GisCoverageId == selectedApoliceCoberturaId
      );

      if (coberturaInfo != null) {
        var initialDate = coberturaInfo.InitialDate;
        var finalDate = coberturaInfo.FinalDate;

        const sinistroData = dayjs(this.objDTO.Sinistro.SinistroData);

        if (
          sinistroData.isBefore(initialDate, "day") ||
          sinistroData.isAfter(finalDate, "day")
        ) {
          this.objDTO.Apolice.ApoliceCoberturaId = null; //Limpar cobertura seleccionada
          this.objDTO.Sinistro.SinistroEventoId = null; //Limpar também possível evento que tivesse seleccionado

          fireVigenciaCoberuraErrorGE();
          return;
        }
      }

      this.objDTO.Sinistro.SinistroEventoId = null;
      this.events = await getEvents(
        this.objDTO.Apolice.ApoliceProdutoId,
        this.objDTO.Apolice.ApoliceCoberturaId,
        this.objDTO.Sinistro.SinistroRamoId
      );
    },
    changeProduto() {
      this.objDTO.ProcessoGDM.IMEI = null;
    },
    async changeLinhaProduto() {
      this.gdmTipo = [];
      this.objDTO.ProcessoGDM.GDMTipoId = null;
      this.gdmTipo = await getGDMTipoByCategoria(this.categoriaId);
    },
  },
  // computed:{
  //   estadoSinistro(){
  //     return this.districts.find(x=>
  //        x.Id === this.objDTO.Sinistro.SinistroDistritoId).Description
  //   }
  // },
  async mounted() {
    this.objDTO = this.$store.getters.getObjDTO;
    await this.policySelected(this.objDTO.Apolice.ApoliceContrato);
    this.optionYN = await getOptions();
    this.districts = await getDistricts();
    this.districtsEnvio = this.districts;
    this.gdmCategoria = await getGDMCategoria();
    // this.gdmTipo = await getGDMTipo();
  },
  beforeDestroy() {
    this.objDTO.Sinistro.SinistroDescricao = null;
    this.objDTO.Apolice.UnidadeDeRiscoExternalId = null;
    this.objDTO.Apolice.ObjectoSeguradoExternalId = null;
    this.objDTO.Apolice.ApoliceCoberturaId = null;
    this.objDTO.Sinistro.SinistroEventoId = null;
    this.objDTO.ProcessoGDM.GDMTipoId = null;
    this.objDTO.ProcessoGDM.IMEI = null;
    this.objDTO.Sinistro.SinistroCodigoPostal = null;
    this.objDTO.Sinistro.SinistroDistritoId = null;
    this.objDTO.Sinistro.SinistroConcelhoId = null;
    this.objDTO.Sinistro.SinistroFreguesiaId = null;
    this.objDTO.Sinistro.SinistroMorada = null;
    this.objDTO.Sinistro.SinistroMoradaNrPorta = null;
    this.objDTO.Sinistro.SinistroLocalReferencia = null;
    this.objDTO.ProcessoGDM.ProdutoEnvioContacto.CodPostal = null;
    this.objDTO.ProcessoGDM.ProdutoEnvioContacto.DistritoId = null;
    this.objDTO.ProcessoGDM.ProdutoEnvioContacto.ConcelhoId = null;
    this.objDTO.ProcessoGDM.ProdutoEnvioContacto.FreguesiaId = null;
    this.objDTO.ProcessoGDM.ProdutoEnvioContacto.Morada = null;
    this.objDTO.ProcessoGDM.ProdutoEnvioContacto.MoradaNrPorta = null;
    this.objDTO.ProcessoGDM.ProdutoEnvioContacto.CodPostalLocalidade = null;
  },
};
</script>
